/**
 * ScopeChip — surface "Showing your customers (N)" context for sales-rep
 * roles whose data view is scoped to a subset of customers.
 *
 * Sprint 16. Reads `scoped` + `scopeCount` from `useAuth()` (set on
 * `/api/auth/me` for outside_sales_rep / inside_sales_rep). Renders
 * nothing for unscoped roles — the chip only fires when there's a story
 * to tell.
 *
 * Place inside the page header band, after the title block, before
 * MetricStrip / primary action. Two modules consume this today
 * (Open Orders + Quotes); a third+ will join in the Day-2 follow-up
 * sprint that scopes Margins / CofA / Pricelists.
 */

import { Users } from 'lucide-react'
import { useAuth } from '@/shell/module-system'

export function ScopeChip() {
  const user = useAuth()
  if (!user.scoped) return null
  const count = user.scopeCount ?? 0
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-md border border-border-subtle bg-surface-sunk px-2.5 py-1 text-xs text-foreground-tertiary"
      role="status"
      aria-label={`Filtered to ${count} assigned customers`}
      title="You are seeing only customers assigned to you (primary or secondary salesperson)."
    >
      <Users size={12} />
      <span className="font-medium text-foreground-secondary">
        Showing your customers
      </span>
      <span className="tabular-nums">({count})</span>
    </span>
  )
}
